module.exports = __webpack_public_path__ + "img/yuexiuqubowuguan.4640e5d1.png";